<template>
  <v-card v-if="ready" class="elevation-0">
    <v-card-text class="pa-1">
      <bar-chart
        title="Dock Capacity"
        sub-title="Warehouses or Docks with no completed appointments won't be displayed on the charts"
        :data="chartData"
        :categories="categories"
        :colors="colors"
        :stacked="true"
        :data-label-formatter="formatDataLabels"
        :show-data-labels="true">
      </bar-chart>
    </v-card-text>
  </v-card>
  <v-skeleton-loader v-else class="mx-auto" type="card"></v-skeleton-loader>
</template>

<script>
import insightsMixin from '@/components/mixins/insightsMixin';

/**
 * Appointments by Status Bar Chart
 * @displayName Appointments by Status Bar Chart
 */
export default {
  mixins: [insightsMixin],
  props: {
    selectedDocks: {
      type: Array,
      required: false,
      default: null
    }
  },
  watch: {
    selectedDocks() {
      this.getData();
    }
  },
  data() {
    return {
      apiEndpoint: 'warehouse/capacity-usage',
      includeVolumeInUri: false,
      categories: [],
      colors: ['#2F8CF7', '#8ACEFF'],
      initialLookbackDays: 0,
      currentRequests: []
    };
  },
  methods: {
    formatXAxis(data) {
      return this.novaCore.ucWords(data);
    },
    async getData() {
      if (this.selectedWarehouse?.length) {
        this.queryParams.warehouseIds = this.novaCore.pluck(this.selectedWarehouse, 'id');
      } else {
        return;
      }
      if (this.selectedDocks?.length) {
        this.queryParams.dockIds = this.selectedDocks;
      }
      const requestData = this.getQueryParams();
      delete requestData.warehouseId;

      const url = `/metrics/${this.apiEndpoint}`;
      const semaphoreKey = encodeURI(`${url}-${JSON.stringify(requestData)}`);

      if (this.currentRequests.includes(semaphoreKey)) {
        return;
      }
      this.currentRequests.push(semaphoreKey);

      axios
        .post(url, requestData)
        .then(response => {
          if (response?.data) {
            this.rawData = response.data.data;
          }
        })
        .finally(
          () => (this.currentRequests = this.currentRequests.filter(r => r !== semaphoreKey))
        );
    },
    formatData() {
      this.chartData = [];
      this.categories = [];
      const tempData = {
        occupiedTime: [],
        idleTime: []
      };
      this.rawData.forEach(warehouse => {
        warehouse.dockCapacities.forEach(dock => {
          tempData.occupiedTime.push(dock.occupiedPct);
          tempData.idleTime.push(dock.idlePct);
          this.categories.push(dock.dockName);
        });
      });

      if (tempData.occupiedTime?.length && tempData.idleTime?.length) {
        this.chartData.push({
          name: 'Occupied Time',
          data: tempData.occupiedTime
        });
        this.chartData.push({
          name: 'Idle Time',
          data: tempData.idleTime
        });
      }

      this.ready = true;
    },
    formatDataLabels(v) {
      return `${v}%`;
    }
  }
};
</script>
